module.exports = __webpack_public_path__ + "streamline-24px.6b8bcbc3a17c961aefc0.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/strahinja.aparac/Desktop/git/source/healthcare/v2/app/appointment-widget/src/assets/fonts/streamline/streamline-24px.svg
// module id = ../../../../../src/assets/fonts/streamline/streamline-24px.svg
// module chunks = styles